// extracted by mini-css-extract-plugin
export var bodyFont = "Footer-module--body-font--xCAWP";
export var borderRadius = "Footer-module--border-radius--t3nRK";
export var clearButtonStyles = "Footer-module--clear-button-styles--PDiYD";
export var footer = "Footer-module--footer--FOC0S";
export var footer_links_home = "Footer-module--footer_links_home--GNJMe";
export var titleFont = "Footer-module--title-font--eoq95";